import { StoreWallInterface } from "../types/store";
import { getRodChainIds } from "./getRodChainIds";
import { useStoreSystem } from "../useStoreSystem";
import { updateItemNameAndPriceWithNomenclature } from "./getItemNomenclatureName";
import { isNewSite } from "../../utils";
import { useShelvingStore } from "../useShelvingStore";

export const updateRodBitrixIds = (sections: StoreWallInterface["sections"]): StoreWallInterface["sections"] => {
    const isNew = isNewSite();
    const rodChainInfo = getRodChainIds(sections);
    const chainMap = new Map(rodChainInfo.map((info) => [info.itemId, info.shouldUseAltId]));

    const itemsGroup = useStoreSystem.getState().itemsGroup;
    const allItems = itemsGroup.flatMap((group) => group.ELEMENTS || []);

    const colorBrackets = useShelvingStore.getState().colorsItems?.brackets;

    const pickRodNm = (originalItem?: any, useAlt?: boolean) => {
        const list = originalItem?.newNomenkl || [];
        if (!list.length) return undefined;
        const byColor = colorBrackets ? list.filter((n: any) => n.color === colorBrackets) : list;
        if (useAlt) {
            return byColor.find((n: any) => n?.nameNomenkl?.includes("Продление")) || byColor[0] || list[0];
        }
        return byColor.find((n: any) => !n?.nameNomenkl?.includes("Продление")) || byColor[0] || list[0];
    };

    return sections.map((section) => ({
        ...section,
        items: section.items.map((item) => {
            if (item.type?.some((t) => t === "Штанга") && chainMap.has(item.id)) {
                const shouldUseAltId = chainMap.get(item.id);

                const baseId = item.bitrixIdOriginal || item.bitrixId;
                const altId = item.bitrixIdAlt;

                if (isNew) {
                    const originalItem = allItems.find(
                        (original) =>
                            original.BITRIX_OFFERS_IDS?.includes(item.bitrixId) ||
                            original.BITRIX_OFFER_ID === item.bitrixId
                    );

                    const nm = pickRodNm(originalItem, shouldUseAltId);
                    const nextBitrixId = (nm?.bitrixId as string) || (shouldUseAltId && altId) || baseId;
                    const nextPrice = (nm?.priceNomenkl as number | undefined) ?? item.price;

                    const updatedItem = {
                        ...item,
                        bitrixId: nextBitrixId,
                        price: nextPrice,
                        bitrixIdAlt: nextBitrixId,
                        priceAlt: nextPrice,
                        bitrixIdOriginal: originalItem?.BITRIX_OFFER_ID,
                    };
                    return updateItemNameAndPriceWithNomenclature(updatedItem, originalItem);
                } else {
                    const originalItem = allItems.find(
                        (original) =>
                            original.BITRIX_OFFER_ID === (item.bitrixIdOriginal || item.bitrixId) ||
                            original.BITRIX_OFFER_ID_ALT === (item.bitrixIdOriginal || item.bitrixId)
                    );

                    const newBitrixId = shouldUseAltId && altId ? altId : baseId;
                    const updatedItem = { ...item, bitrixId: newBitrixId };
                    return updateItemNameAndPriceWithNomenclature(updatedItem, originalItem);
                }
            }
            return item;
        }),
    }));
};
